// src/App.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { NotificationCenterProvider } from './context/NotificationCenterContext';

// Import PageTitle Component
import PageTitle from './components/common/PageTitle';
// Atau jika taruh langsung di components folder:
// import PageTitle from './components/PageTitle';

// Public Pages
import HomePage from './pages/public/HomePage';
import VillasPage from './pages/public/VillasPage';
import VillaDetailPage from './pages/public/VillaDetailPage';
import BusinessPage from './pages/public/BusinessPage';
import ServicesPage from './pages/public/ServicesPage';
import ProfilePage from './pages/public/ProfilePage';
import ContactPage from './pages/public/ContactPage';

import AdminLayout from './components/layout/AdminLayout';

// Admin Pages
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import VillaManagementPage from './pages/admin/VillaManagementPage';
import BusinessManagementPage from './pages/admin/BusinessManagementPage';
import ServiceManagementPage from './pages/admin/ServiceManagementPage';
import ContactManagementPage from './pages/admin/ContactManagementPage';
import SettingsPage from './pages/admin/SettingsPage';

// Other Pages
import NotFoundPage from './pages/NotFoundPage';

// Components
import ProtectedRoute from './components/common/ProtectedRoute';

// Styles
import './App.css';

function App() {
  return (
    <NotificationCenterProvider>
      {/* Add PageTitle component here */}
      <PageTitle />
      
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/villas" element={<VillasPage />} />
          <Route path="/villas/:id" element={<VillaDetailPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="villas" element={<VillaManagementPage />} />
            <Route path="business" element={<BusinessManagementPage />} />
            <Route path="services" element={<ServiceManagementPage />} />
            <Route path="contacts" element={<ContactManagementPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* 404 Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        {/* Toast Notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              theme: {
                primary: '#4aed88',
              },
            },
          }}
        />
      </div>
    </NotificationCenterProvider>
  );
}

export default App;